import "../features/product/hydration/ProductsContainerHydration";
import "../features/product/hydration/SingleProductContainerHydration";
import "../features/contact/hydration/ContactContainerHydration";
import "../features/cart/hydration/CartPageHydration";
import "../features/checkout/hydration/CheckoutPageHydration";
import "../features/header/headerActions/hydration/HeaderActionsContainerHydration";
import "../features/header/mobileActions/hydration/MobileActionsContainerHydration";
import "../features/order/hydration/OrderPageHydration";
import "../features/home/partials/featuredProducts/FeaturedProductsHydration";
import "../features/header/productCategoryDropdown/hydration/ProductsCategoryDropdownHydration";
import "../features/header/headerSearchBar/hydration/HeaderSearchBarHydration"; // New import

// Define types for our component mappings
interface ComponentMapping {
  id: string;
  hydrateFn: string;
}

// Define global hydration functions that will be attached to window
declare global {
  interface Window {
    hydrateProductsContainer?: (id: string) => void;
    hydrateSingleProductContainer?: (id: string) => void;
    hydrateContactContainer?: (id: string) => void;
    hydrateCartPageContainer?: (id: string) => void;
    hydrateCheckoutContainer?: (id: string) => void;
    hydrateHeaderActionsContainer?: (id: string) => void;
    hydrateMobileActionsContainer?: (id: string) => void;
    hydrateOrderPageContainer?: (id: string) => void;
    hydrateFeaturedProducts?: (id: string) => void;
    hydrateProductsCategoryDropdown?: (id: string) => void;
    hydrateHeaderSearchBar?: (id: string) => void; // Add new hydration function
    [key: string]: any;
  }
}

const initHydration = (): void => {
  console.log("Hydration system initialized");

  // Hydrate single-instance components
  const singleInstanceMappings: ComponentMapping[] = [
    { id: "products-archive-root", hydrateFn: "hydrateProductsContainer" },
    { id: "single-product-root", hydrateFn: "hydrateSingleProductContainer" },
    { id: "contact-root", hydrateFn: "hydrateContactContainer" },
    { id: "cart-page-root", hydrateFn: "hydrateCartPageContainer" },
    { id: "checkout-root", hydrateFn: "hydrateCheckoutContainer" },
    {
      id: "header-actions-container",
      hydrateFn: "hydrateHeaderActionsContainer",
    },
    {
      id: "mobile-actions-container",
      hydrateFn: "hydrateMobileActionsContainer",
    },
    { id: "order-page-root", hydrateFn: "hydrateOrderPageContainer" },
    {
      id: "products-category-dropdown-root",
      hydrateFn: "hydrateProductsCategoryDropdown",
    },
    { id: "header-search-bar-root", hydrateFn: "hydrateHeaderSearchBar" }, // Add new mapping
  ];

  singleInstanceMappings.forEach(({ id, hydrateFn }) => {
    const rootElement = document.getElementById(id);
    if (rootElement && typeof window[hydrateFn] === "function") {
      if (rootElement.dataset.reactInitialized !== "true") {
        window[hydrateFn](id);
      } else {
        console.log(
          `Skipping hydration for already initialized container: ${id}`
        );
      }
    } else if (rootElement && typeof window[hydrateFn] !== "function") {
      console.warn(
        `Hydration function ${hydrateFn} not found for element ${id}`
      );
    }
  });

  // Hydrate multiple-instance components by attribute
  const multiInstanceSelector = '[data-component="featured-products"]';
  const featuredProductElements = document.querySelectorAll(
    multiInstanceSelector
  );

  featuredProductElements.forEach((element) => {
    const rootId = element.id;
    const hydrateFnName = "hydrateFeaturedProducts";

    if (rootId && typeof window[hydrateFnName] === "function") {
      if (element.getAttribute("data-react-initialized") !== "true") {
        window[hydrateFnName](rootId);
      }
    } else if (!rootId) {
      console.warn(
        `Element with selector '${multiInstanceSelector}' has no ID. Cannot hydrate.`
      );
    }
  });
};

if (typeof window !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHydration);
  } else {
    initHydration();
  }
}

export default initHydration;
